import { X } from "lucide-react";
import { STATUS_OPTIONS } from "./messageStatus";

const Field = ({ label, value, link, multiline }) => {
    if (value == null || value === "") return null;
    return (
        <div>
            <p className="text-[11.5px] uppercase tracking-wider text-[#6F6B63] mb-1">
                {label}
            </p>
            {link ? (
                <a href={link} className="text-[#0E2A47] hover:underline break-words">
                    {value}
                </a>
            ) : (
                <p className={`text-[#1A2230] ${multiline ? "whitespace-pre-wrap" : ""}`}>
                    {value}
                </p>
            )}
        </div>
    );
};

export default function ContactDetail({ row, onClose, onUpdate }) {
    if (!row) return null;
    return (
        <div
            className="fixed inset-0 z-50 bg-[#1A2230]/40 backdrop-blur-sm"
            onClick={onClose}
            data-testid="contact-detail"
        >
            <div
                className="absolute right-0 top-0 h-full w-full sm:w-[480px] bg-white shadow-2xl overflow-y-auto"
                onClick={(e) => e.stopPropagation()}
            >
                <div className="sticky top-0 bg-white border-b border-[#E5DFD3] px-6 py-4 flex items-center justify-between">
                    <div>
                        <p className="text-[11px] uppercase tracking-[0.18em] text-[#C8A24A] font-medium">
                            Message
                        </p>
                        <h3 className="font-[Outfit] text-[18px] font-semibold tracking-tight">
                            {row.name}
                        </h3>
                    </div>
                    <button
                        onClick={onClose}
                        className="p-2 rounded-full hover:bg-[#EFEBE0]"
                        data-testid="contact-detail-close"
                    >
                        <X className="h-4 w-4" />
                    </button>
                </div>
                <div className="p-6 space-y-5 text-[14px]">
                    <div>
                        <p className="rtc-label">Status</p>
                        <div className="flex flex-wrap gap-2">
                            {STATUS_OPTIONS.map((s) => (
                                <button
                                    key={s}
                                    onClick={() => onUpdate(row.id, s)}
                                    data-testid={`msg-status-${s}`}
                                    className={`px-3 py-1.5 rounded-full text-[12.5px] font-medium border transition-colors ${
                                        row.status === s
                                            ? "bg-[#0E2A47] text-white border-[#0E2A47]"
                                            : "bg-white text-[#1A2230] border-[#E5DFD3] hover:border-[#0E2A47]"
                                    }`}
                                >
                                    {s}
                                </button>
                            ))}
                        </div>
                    </div>
                    <Field label="Email" value={row.email} link={`mailto:${row.email}`} />
                    <Field
                        label="Phone"
                        value={row.phone}
                        link={row.phone ? `tel:${row.phone}` : null}
                    />
                    <Field label="Subject" value={row.subject} />
                    <Field label="Message" value={row.message} multiline />
                    <Field
                        label="Received"
                        value={new Date(row.created_at).toLocaleString()}
                    />
                </div>
            </div>
        </div>
    );
}
